module.exports = __webpack_public_path__ + "img/H000030_popcandy.f4649585.png";